export default __webpack_public_path__ + "static/media/DonaQR.44964da42f98d07d377f5bb1fb2c07e0.webp";